export enum JobsChannel {
    MetaMarketing = 'meta_marketing',
    LinkedinMarketing = 'linkedin_marketing',
    GoogleDisplayNetwork = 'google_display_network',
    YoutubeAdvertising = 'youtube_advertising',
    SnapchatAds = 'snapchat_ads',
    TiktokAds = 'tiktok_ads',
    RedditAds = 'reddit_ads',
    GoogleSearch = 'google_search',
}

export const JobsChannelToNameMap = new Map<JobsChannel, string>([
    [JobsChannel.MetaMarketing, 'Meta Business Suite'],
    [JobsChannel.LinkedinMarketing, 'Linkedin Marketing'],
]);
